import { render, staticRenderFns } from "./Step4-terrace.vue?vue&type=template&id=5626008d&scoped=true&"
import script from "./Step4-terrace.vue?vue&type=script&lang=js&"
export * from "./Step4-terrace.vue?vue&type=script&lang=js&"
import style0 from "./Step4-terrace.vue?vue&type=style&index=0&id=5626008d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5626008d",
  null
  
)

export default component.exports